import React, { useState } from "react";
import {TableRow, TableCell, IconButton, Box} from "@mui/material";
import CustomCheckbox from "../../../../../../../components/Checkbox";
import BidPopover from "../../BidPopover";
import Icons from "../../../../../../../components/DmpIcons/icons";
import ConfirmDeleteModal from "../../ConfirmDeleteModal";

export const MarketBidBody = ({ rows, selectedRows, setSelectedRows, updateRow, onDeleteRow }) => {
    const [deleteTargetId, setDeleteTargetId] = useState(null);

    const toggleRow = (id) => {
        setSelectedRows(prev =>
            prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
        );
    };

    const handleConfirmDelete = () => {
        if (onDeleteRow && deleteTargetId !== null) {
            onDeleteRow(deleteTargetId);
        }
        setDeleteTargetId(null);
    };

    return (
        <>
            {rows.map((row) => {
                const handleUpdateBidValue = () => {
                    updateRow();
                };

                return (
                    <TableRow key={row.id}>
                        <TableCell>
                            {row.can_delete === true ? (
                                <CustomCheckbox
                                    checked={selectedRows.includes(row.id)}
                                    onChange={() => toggleRow(row.id)}
                                    title={row.label_entity}
                                    checkboxStyles={{ padding: "2px 16px 2px 9px" }}
                                    labelStyles={{
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        fontSize: 10,
                                        letterSpacing: 0,
                                        verticalAlign: "middle",
                                        color: "#454545",
                                        paddingTop: "2px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                />
                            ) : (
                                <Box sx={{ marginLeft: "28px" }}>{row.label_entity}</Box>
                            )}
                        </TableCell>
                        <TableCell>{row.label_device}</TableCell>
                        <TableCell>{row.label_market}</TableCell>
                        <TableCell>
                            <BidPopover
                                bid={{
                                    bid_label: `${row.bidding_option}`,
                                    bid_symbol: "",
                                    bid_editable: row?.can_edit === true,
                                    bid_edit_in_place_title: row?.bid_edit_in_place_title,
                                    bid_history_path: row?.bid_history_path,
                                    bid_value_edit_path: row?.bid_value_edit_path,
                                    platform: "KAYAK"
                                }}
                                onUpdateBidValue={() =>
                                    handleUpdateBidValue()
                                }
                            />
                        </TableCell>
                        <TableCell>
                            {row.bidding_label}
                        </TableCell>
                        <TableCell>
                            {row?.can_delete === true && (
                                <IconButton size="small" onClick={() => setDeleteTargetId(row.id)}>
                                    <img
                                        src={Icons.ActionsIconsSVG.DeleteIconSVG}
                                        alt="Delete"
                                        className="icon"
                                        style={{
                                            paddingLeft: "40%",
                                            width: "10px",
                                            height: "12px"
                                        }}
                                    />
                                </IconButton>
                            )}
                        </TableCell>
                    </TableRow>
                );
            })}

            {/* Delete Confirmation Modal */}
            <ConfirmDeleteModal
                open={deleteTargetId !== null}
                onClose={() => setDeleteTargetId(null)}
                onConfirm={handleConfirmDelete}
                title="Delete Row"
                message="Are you sure you want to delete this row?"
            />
        </>
    );
};